import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterByProductName',
    pure: false
})
export class FilterByProductNamePipe implements PipeTransform {
    transform(items: any[], searchText: string): any {
        
        if (!items || !searchText) {
            return items;
        }

        return items.filter(it => {
            return it.internalCode?.toLowerCase().includes(searchText.toLowerCase()) || it.name?.toLowerCase().includes(searchText.toLowerCase());
        });

        
    }
}